<template>
  <div class="documents-component screen">
    <div class="header-band">
      <AdminModalMenu @close="beforeClose()" />
      <div class="title-group">
        <span class="title">My admin</span>
        <div class="divider"></div>
        <span class="subtitle">Documents</span>
      </div>
      <CloseButton variant="light" inline @click="beforeClose()" />
    </div>
    <div class="panel">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="block" @click="getLatestStatement()">
              <div class="icon">
                <Spinner large v-if="latestStatementDownloading && !$isIOS" />
                <img src="~@/assets/images/statement.svg" width="34" height="34" alt="Latest Statement" v-else />
              </div>
              <div class="title">
                Latest
                <br />
                <span>statement</span>
              </div>
              <div class="footer">
                <svg width="20" height="20" viewBox="0 0 15.34 12.34" class="download-icon">
                  <g>
                    <polyline style="fill: none; stroke-width: 1.5" points="14.59,5.94 14.59,11.59 0.75,11.59 0.75,5.94" />
                    <polyline style="fill: none; stroke-width: 1.5" points="10.07,5.94 7.67,8.34 5.26,5.94" />
                    <line style="fill: none; stroke-width: 1.5" x1="7.67" y1="8.34" x2="7.67" y2="0.75" />
                  </g>
                </svg>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="block" @click="getLatestInvoice()">
              <div class="icon">
                <Spinner large v-if="latestInvoiceDownloading && !$isIOS" />
                <img src="~@/assets/images/invoice.svg" width="34" height="34" alt="Latest Invoice" v-else />
              </div>
              <div class="title">
                Latest
                <br />
                <span>invoice</span>
              </div>
              <div class="footer">
                <svg width="20" height="20" viewBox="0 0 15.34 12.34" class="download-icon">
                  <g>
                    <polyline style="fill: none; stroke-width: 1.5" points="14.59,5.94 14.59,11.59 0.75,11.59 0.75,5.94" />
                    <polyline style="fill: none; stroke-width: 1.5" points="10.07,5.94 7.67,8.34 5.26,5.94" />
                    <line style="fill: none; stroke-width: 1.5" x1="7.67" y1="8.34" x2="7.67" y2="0.75" />
                  </g>
                </svg>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="block" @click="getAccountSummary()">
              <div class="icon">
                <Spinner large v-if="accountSummaryDownloading && !$isIOS" />
                <img src="~@/assets/images/account-summary.svg" width="34" height="34" alt="Account Summary" v-else />
              </div>
              <div class="title">
                Account
                <br />
                <span>summary</span>
              </div>
              <div class="footer">
                <svg width="20" height="20" viewBox="0 0 15.34 12.34" class="download-icon">
                  <g>
                    <polyline style="fill: none; stroke-width: 1.5" points="14.59,5.94 14.59,11.59 0.75,11.59 0.75,5.94" />
                    <polyline style="fill: none; stroke-width: 1.5" points="10.07,5.94 7.67,8.34 5.26,5.94" />
                    <line style="fill: none; stroke-width: 1.5" x1="7.67" y1="8.34" x2="7.67" y2="0.75" />
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
        <!--<div class="row">
          <div class="col-12 col-md-6">
            <div class="block">
              <div class="icon">
                <img src="~@/assets/images/contract.svg" alt="Your Contract" />
              </div>
              <div class="title">
                YOUR
                <br />
                <span>CONTRACT</span>
              </div>
              <div class="footer">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                  class="download-icon"
                >
                  <path
                    fill-rule="evenodd"
                    d="M.5 8a.5.5 0 0 1 .5.5V12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8.5a.5.5 0 0 1 1 0V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8.5A.5.5 0 0 1 .5 8z"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M5 7.5a.5.5 0 0 1 .707 0L8 9.793 10.293 7.5a.5.5 0 1 1 .707.707l-2.646 2.647a.5.5 0 0 1-.708 0L5 8.207A.5.5 0 0 1 5 7.5z"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0v-8A.5.5 0 0 1 8 1z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.documents-component {
  .header-band {
    display: flex;
    align-items: center;
    background-color: $brand-color-1;
    height: 54px;
    padding: 0 30px;
    margin: -20px -30px 25px -30px;
    color: #fff;
    position: relative;
    font-size: 1.1875rem;

    /deep/ .menu-button .icon {
      fill: #fff;
    }

    .title-group {
      display: flex;
      align-items: center;
      flex: 1;
    }

    .title {
      font-weight: 600;
      color: #fff;
      margin-left: 5px;
    }

    .divider {
      width: 1px;
      height: 20px;
      background-color: #fff;
      margin: 0 15px;

      &.divider-wide {
        margin: 0 40px 0 15px;
      }
    }

    .subtitle {
      color: #fff;
    }
  }

  .panel {
    background: $brand-color-4;
    padding: 30px 15px 0 15px;

    .row {
      .col-12 {
        margin-bottom: 30px;
      }
    }

    .block {
      background: #fff;
      text-align: center;
      padding-top: 15px;
      box-shadow: $drop-shadow;

      .icon {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;

        img {
          height: 80%;
        }
      }

      .title {
        color: $brand-color-1;
        font-size: 1rem;
        line-height: 1.25rem;
        font-weight: 300;
        margin-top: 5px;

        span {
          font-weight: 600;
        }
      }

      .footer {
        background: $brand-color-2;
        position: relative;
        bottom: -5px;
        width: 60px;
        height: 30px;
        padding-top: 3px;
        margin: 0 auto;
        border-top-left-radius: 60px;
        border-top-right-radius: 60px;

        .download-icon {
          stroke: #fff;
        }
      }

      &:hover {
        cursor: pointer;

        .footer {
          background: $brand-color-1;
        }
      }
    }
  }
}

@media (max-width: $md-1) {
  .documents-component {
    .header-band {
      align-items: flex-start;
      background-color: #fff;
      color: $brand-color-1;
      margin-top: -5px;

      /deep/ .menu-button .icon {
        fill: $brand-color-1;
      }

      .title-group {
        flex-direction: column;
        align-items: flex-start;
      }

      .title {
        font-weight: 600;
        font-size: 19px;
        line-height: 1.25rem;
        color: $brand-color-1;
        margin-left: 0;
      }

      .divider {
        display: none;
      }

      .subtitle {
        font-weight: 300;
        font-size: 19px;
        color: $brand-color-1;
      }

      /deep/ .close-button svg path {
        fill: $brand-color-1;
      }
    }
  }
}
</style>

<script>
import { downloadService } from "@/services";
import { helper } from "@/helper";
import AdminModalMenu from "@/components/screens/AdminModalMenu";
import CloseButton from "@/components/CloseButton";

export default {
  name: "Documents",
  components: {
    AdminModalMenu,
    CloseButton,
  },
  data() {
    return {
      latestStatementDownloading: false,
      latestInvoiceDownloading: false,
      accountSummaryDownloading: false,
    };
  },
  methods: {
    beforeClose() {
      this.$emit("close");
    },
    getLatestStatement() {
      if (!this.latestStatementDownloading) {
        this.latestStatementDownloading = true;
        downloadService
          .getLatestStatement()
          .then((data) => {
            this.latestStatementDownloading = false;
            helper.saveToBrowser("Latest Statement.pdf", data);
          })
          .catch((error) => {});
      }
    },
    getLatestInvoice() {
      if (!this.latestInvoiceDownloading) {
        this.latestInvoiceDownloading = true;
        downloadService
          .getLatestInvoice()
          .then((data) => {
            this.latestInvoiceDownloading = false;
            helper.saveToBrowser("Latest Invoice.pdf", data);
          })
          .catch((error) => {});
      }
    },
    getAccountSummary() {
      if (!this.accountSummaryDownloading) {
        this.accountSummaryDownloading = true;
        downloadService
          .getAccountSummary()
          .then((data) => {
            this.accountSummaryDownloading = false;
            helper.saveToBrowser("Account Summary.pdf", data);
          })
          .catch((error) => {});
      }
    },
  },
};
</script>